// extracted by mini-css-extract-plugin
module.exports = {"stuDetail":"index_stuDetail__36cfN","tableStyle":"index_tableStyle__1RkxA","pagination":"index_pagination__yZTmG"};